// ReduxVoucherSlice.js
import { createSlice } from "@reduxjs/toolkit";

const ReduxVoucherSlice = createSlice({
  name: "vouchers",
  initialState: {
    voucherList: [],
  },
  reducers: {
    addVoucher: (state, action) => {
      state.voucherList.push(action.payload);
    },
    removeVoucher: (state, action) => {
      state.voucherList = state.voucherList.filter(
        (voucher) => voucher.vouchercode !== action.payload
      );
    },
    resetVouchers: (state) => {
      state.voucherList = [];
    },
  },
});

export const { addVoucher, removeVoucher, resetVouchers } =
  ReduxVoucherSlice.actions;
export default ReduxVoucherSlice.reducer;
